import './QuestionListView.sass';

import React from 'react';

import QuestionDetailsContainer from '../../commonComponents/QuestionDetails/QuestionDetailsContainer';
import QuestionInfiniteListContainer from '../../commonComponents/QuestionInfiniteList/QuestionInfiniteListContainer';

export default class QuestionListView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="ContentRow">
        <QuestionInfiniteListContainer
          loadAllQuestions={this.props.loadAllQuestions}
        />
        <QuestionDetailsContainer
          permissionPrefix={this.props.permissionPrefix}
        />
      </div>
    );
  }
}
